import React from 'react'
import '../index.css'

export default function Changer  () {
  return (
    <>
    <marquee behavior="" direction=""><div class="ticker__element">
    <p class="css-ph13k3-Typography-mono1"><span>&nbsp;&nbsp;&nbsp;Installation&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp; tests safety devices&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp; fix appliances&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp; installation of new gas lines&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp;repairing gas piping systems&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp;checks for gas leaks&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp;general support&nbsp;&nbsp;&nbsp;-</span><span>&nbsp;&nbsp;&nbsp;for support call: +234-808 35XX 89X&nbsp;&nbsp;&nbsp;</span></p></div></marquee>
    </>
  )
}
